// RosterList.js
import React, { useEffect } from 'react';
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Box,
    IconButton,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DeleteIcon from '@mui/icons-material/Delete';
import RosterImport from './RosterImport';
import StudentList from './StudentList';

const RosterList = ({
                        rosters,
                        expandedRoster,
                        setExpandedRoster,
                        handleFileUpload,
                        handleDeleteRoster,
                        handleExportSummary,
                        handleMELSelect,
                        studentStatuses,
                        activeUsers,
                        registeredUsers,
                        selectedMEL,
                        fileInputKey,
                        currentModel,
                        userEmailToId
                    }) => {
    // Clear expanded roster if it no longer exists
    useEffect(() => {
        if (expandedRoster && !rosters.find(r => r.id === expandedRoster)) {
            setExpandedRoster(null);
        }
    }, [rosters, expandedRoster, setExpandedRoster]);

    const handleDelete = async (e, rosterId) => {
        e.stopPropagation();
        try {
            await handleDeleteRoster(rosterId);
            setExpandedRoster(null);
        } catch (error) {
            console.error('Error deleting roster:', error);
        }
    };

    return (
        <>
            {rosters.map((roster) => (
                <Accordion
                    key={roster.id}
                    expanded={expandedRoster === roster.id}
                    onChange={() => setExpandedRoster(expandedRoster === roster.id ? null : roster.id)}
                >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%',
                            gap: 1
                        }}>
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                width: '100%'
                            }}>
                                <Box sx={{ flex: 1 }}>
                                    <Typography variant="subtitle1">{roster.name}</Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        ({roster.students?.length || 0} students)
                                    </Typography>
                                </Box>
                                <IconButton
                                    size="small"
                                    onClick={(e) => handleDelete(e, roster.id)}
                                    sx={{ ml: 1 }}
                                >
                                    <DeleteIcon />
                                </IconButton>
                            </Box>
                            <Typography
                                variant="h6"
                                sx={{
                                    color: 'primary.main',
                                    fontSize: '1.1rem',
                                    fontWeight: 500,
                                    letterSpacing: '0.05em'
                                }}
                            >
                                Class Code: {roster.classCode}
                            </Typography>
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Box>
                            <RosterImport
                                rosterId={roster.id}
                                handleFileUpload={handleFileUpload}
                                fileInputKey={fileInputKey}
                            />

                            <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
                                Student List
                            </Typography>

                            <StudentList
                                roster={roster}
                                studentStatuses={studentStatuses}
                                activeUsers={activeUsers}
                                registeredUsers={registeredUsers}
                                selectedMEL={selectedMEL}
                                handleMELSelect={handleMELSelect}
                                handleExportSummary={handleExportSummary}
                                currentModel={currentModel}
                                userEmailToId={userEmailToId}
                            />
                        </Box>
                    </AccordionDetails>
                </Accordion>
            ))}
        </>
    );
};
export default RosterList;